import _cloneDeep from 'lodash/cloneDeep';
import _isEqual from 'lodash/isEqual';

export default {
    props: ['value'],
    data() {
        return {
            input: null,
        };
    },
    created() {
        this._customInputLoaded = false; // used as a lock to control the first time the input is processed.
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newVal) {
                if (this._customInputLoaded && _isEqual(this.input, newVal)) {
                    return;
                }

                this._customInputLoaded = true;

                this.input = this._cleanValue(_cloneDeep(newVal));
            },
        },
        input: {
            deep: true,
            handler(newVal) {
                if (_isEqual(newVal, this.value)) return;

                this.$emit('input', newVal);
            },
        },
    },
    methods: {
        /**
         * Called when the v-model is changed from outside the component. Can be overridden to make adjustments.
         *
         * @param newVal
         * @returns {*}
         * @private
         */
        _cleanValue(newVal) {
            return newVal;
        },
    },
};
